import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Block } from "./library/container";
export const HighlightBlock = (p)=>/*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "highlight container--sg align--center",
            children: [
                /*#__PURE__*/ _jsx("h2", {
                    className: "highlight__title title--l",
                    children: p.title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "highlight__subtitle text--l",
                    children: p.subtitle
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "highlight__text text--styled",
                    dangerouslySetInnerHTML: {
                        __html: p.content
                    }
                })
            ]
        })
    });
{}